import { ResponseValueObject } from '@gishub/domain';
import axios from 'axios';

const GEOPERU_PATH = '/geoperu/general/datos';

export class GeoperuRepository {
  async getData(ubigeo: string): Promise<ResponseValueObject<any | null>> {
    try {
      const url = `${GEOPERU_PATH}/${ubigeo}`;
      const res = await axios.get(url, { timeout: 30_000 });
      return new ResponseValueObject(true, res.data);
    } catch (err: any) {
      return new ResponseValueObject(false, null, err?.message ?? 'Error fetching geoperu data');
    }
  }
}